import { useState } from 'react'
import ListOut from '@components/shared/ListOut'
import Link from 'next/link'
import useT from '@hooks/useTranslation'
import withBreakpoints from '@hoc/withBreakpoints'
import plural from '@utils/grammar/plural'

import styles from 'styles/MakeModelLinks.module.css'

const MakeModelLinks = ({ breakpoints,
    links, linkBase, make, minSize = 10, prefix, show, titles, viewOnMobile = true }) => {

    if (!show) return null

    const linkCount = links?.length
    const [showAll, setShowAll] = useState(linkCount <= minSize)

    const zobaczWiecej = useT('Zobacz wiecej')
    const samochody = useT(titles[0] || 'Marki')
    const modele = useT(titles[1] || 'Modele')

    if (!viewOnMobile && breakpoints.mobile) return null
    if (links?.length) {
        const viewLinks = showAll
            ? links
            : links.slice(0, minSize)

        return (
            <div className={styles.wrapper}>
                <br/>
                <h3>{make ? `${modele} ${make}` : samochody}</h3>
                <ListOut
                    Component={MakeModelLink}
                    id="displayName"
                    items={viewLinks}
                    linkBase={linkBase}
                    prefix={prefix} />

                { !showAll && <button
                    onClick={() => setShowAll(true)}
                    className={styles.btn}>{zobaczWiecej}...</button> }
            </div>
        )

    } else {
        return null
    }
}

function MakeModelLink ({ count, linkBase, make, model = '', prefix = '' }) {
    let displayName
    let href

    if (model) {
        displayName = `${make} ${model}`
        href = `${linkBase}/${encodeURIComponent(make)}/${encodeURIComponent(model)}` // <- simplified link, risk of breaking with changes
    } else {
        displayName = make
        href = `${linkBase}/${encodeURIComponent(make)}`
    }

    const countText = plural(count, ['ogłoszenie','ogłoszenia','ogłoszeń'])

    return (
        <span className={styles.link}>
            <Link href={href}>
                <a
                    className={styles.name}
                    title={`${count} ${countText} ${displayName}`}>{withPrefix(displayName, prefix)}</a>
            </Link>
            <span className={styles.count}>{count}</span>
        </span>
    )
}

function withPrefix (text, prefix) {
    return prefix
        ? `${prefix} ${text}`
        : text
}

export default
    withBreakpoints({ mobile: 800 })(
        MakeModelLinks)